import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../service/caller';
import Select from 'react-select';
import './newanalyse.css';

const ServiceSelection = ({ onServicesChange, appointment }) => {
    const [servicesOfferts, setServicesOfferts] = useState([]);
    const [servicesRecommandes, setServicesRecommandes] = useState([]);
    const [selectedServicesOfferts, setSelectedServicesOfferts] = useState([]);
    const [selectedServicesRecommandes, setSelectedServicesRecommandes] = useState([]);
    const [isOffertOpen, setIsOffertOpen] = useState(false);
    const [isRecommandeOpen, setIsRecommandeOpen] = useState(false);
    const [UserData, setUserData] = useState([]);


    // les information de l'utilisateur
    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                console.error("Erreur récupération UserData:", error);
            }
        };
        fetchLoggedUserData();
    }, []);


    // Fetch services offerts
    const fetchRecommendedServices = async () => {
        try {
            const response = await api.get('api/services');
            console.log("fgc000f",response.data.data)
            const serviceOptions = response.data.data.map(service => ({
                value: service._id,
                label: `${service.name} ------------------- ${service.price_service} XOF `,
                name: service.name,
                price: service.price_service,
                hospitalId: service.hospital_id,
                id: service._id,
            }));
            setServicesRecommandes(serviceOptions);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        console.log("fgcf",appointment)
        const fetchOfferedServices = async () => {
    
            try {
                const userSpecialties = UserData.specialties;
    
                if (!userSpecialties) {
                    console.warn("Aucune spécialité trouvée pour l'utilisateur.");
                    return;
                }
    
                let allServices = [];
    
                for (const specialty of userSpecialties) {
                    const response = await api.get(`api/services/specialty/${specialty._id}`);
                    allServices = [...allServices, ...response.data.data];
                }
    
                const uniqueServices = Array.from(
                    new Map(allServices.map(service => [service._id, service])).values()
                );

                const serviceOptions = uniqueServices.map(service => ({
                    value: service._id,
                    label: `${service.name} ------------------- ${service.price_service} XOF `,
                    price: service.price_service,
                    name: service.name,
                    id: service._id,
                }));
    
                setServicesOfferts(serviceOptions);
            } catch (err) {
                console.error(" Erreur dans fetchOfferedServices :", err);
            }
        };
        if (UserData && UserData.specialties?.length > 0) {
            fetchOfferedServices();
        }
    }, [UserData]);


    useEffect(() => {
        fetchRecommendedServices();
    }, []);

    const handleOffertChange = (selectedOptions) => {
        setSelectedServicesOfferts(selectedOptions);
        onServicesChange(selectedOptions, 'offert');
    };

    const handleRecommandeChange = (selectedOptions) => {
        setSelectedServicesRecommandes(selectedOptions);
        onServicesChange(selectedOptions, 'recommande');
    };

    // Fonction de rendu des services sélectionnés
    const renderSelectedServicesTable = (selectedServices, showPrice = true) => {
        const total = selectedServices.reduce((acc, option) => {
            if (showPrice && option.price) {
                const price = parseFloat(option.price.replace(/[^0-9.-]+/g, ''));
                return acc + price;
            }
            return acc;
        }, 0);

        return (
            <table className="service-table">
                <thead>
                    <tr>
                        <th>Nom du Service</th>
                        {showPrice && <th>Prix</th>}
                    </tr>
                </thead>
                <tbody>
                    {selectedServices.map((service, index) => (
                        <tr key={index}>
                            <td>{service.name}</td>
                            {showPrice && <td>{service.price}</td>}
                        </tr>
                    ))}
                    {showPrice && (
                        <tr className="total-row">
                            <td><strong>Total</strong></td>
                            <td><strong>{total} FCFA</strong></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    };

    return (
        <div className="service-selection-container">
            <div className="position-relative">
                <p className="py-3 fw-bold ms-5" onClick={() => setIsOffertOpen(!isOffertOpen)}>
                    Services Offerts
                    <i className={`bi ${isOffertOpen ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`} style={{ color: '#FF9800' }}></i>
                </p>
            </div>

            {isOffertOpen && (
                <div className="service-dropdown">
                    <Select
                        isMulti
                        options={servicesOfferts}
                        onChange={handleOffertChange}
                        getOptionLabel={(e) => `${e.label}`}
                        placeholder="Rechercher un service offert..."
                        className="react-select"
                    />
                    {selectedServicesOfferts.length > 0 && renderSelectedServicesTable(selectedServicesOfferts, true)}
                </div>
            )}

            <div className="position-relative">
                <p className="py-3 fw-bold ms-5" onClick={() => setIsRecommandeOpen(!isRecommandeOpen)}>
                    Services Recommandés
                    <i className={`bi ${isRecommandeOpen ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`} style={{ color: '#FF9800' }}></i>
                </p>
            </div>

            {isRecommandeOpen && (
                <div className="service-dropdown">
                    <Select
                        isMulti
                        options={servicesRecommandes.filter(serv => serv?.hospitalId === appointment?.hospitalId)}
                        onChange={handleRecommandeChange}
                        getOptionLabel={(e) => `${e.label}`}
                        placeholder="Rechercher un service recommandé..."
                        className="react-select"
                    />
                    {selectedServicesRecommandes.length > 0 && renderSelectedServicesTable(selectedServicesRecommandes, true)}
                </div>
            )}
        </div>
    );
};

export default ServiceSelection;
